import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/table/style";
import _Table from "antd/lib/table";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/empty/style";
import _Empty from "antd/lib/empty";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { CloseOutlined, FileTextOutlined, SearchOutlined } from '@ant-design/icons';
import ExploreSelect from 'components/repository/ExploreSelect';
import DownloadButton from 'components/repository/DownloadButton';
import { modules } from 'const';
import { useAppRouter } from 'utils/AppRouteProvider';
import { getTechNameToDisplay } from 'const/enums/SampleTech';
var Paragraph = _Typography.Paragraph;
var RepositoryTable = function RepositoryTable(props) {
  var router = useRouter();
  var _useState = useState(''),
    searchQuery = _useState[0],
    setSearchQuery = _useState[1];
  useEffect(function () {
    if (router.isReady && router.query.search) {
      setSearchQuery(router.query.search);
    }
  }, [router.isReady]);
  var matchesSearch = function matchesSearch(row, query) {
    var _row$cellCount, _row$sampleTechnologi;
    if (!query) return true;
    var q = query.toLowerCase();
    var fields = [row.name, row.description, row.publicationTitle, row.dataSourceTitle, row.species, row.sampleCount, String((_row$cellCount = row.cellCount) !== null && _row$cellCount !== void 0 ? _row$cellCount : ''), (_row$sampleTechnologi = row.sampleTechnologies) === null || _row$sampleTechnologi === void 0 ? void 0 : _row$sampleTechnologi.map(function (tech) {
      return getTechNameToDisplay(tech);
    }).join(' ')];
    return fields.some(function (f) {
      return f === null || f === void 0 ? void 0 : f.toLowerCase().includes(q);
    });
  };
  var LICENSE_URLS = {
    'CC BY 4.0': 'https://creativecommons.org/licenses/by/4.0/',
    'CC BY-NC 4.0': 'https://creativecommons.org/licenses/by-nc/4.0/'
  };

  // Make ready-to-use rows for the table
  // e.g. turn sourceTitle+sourceUrl into a single <a> tag, etc.
  var formatData = function formatData(data) {
    return data.map(function (row) {
      return {
        key: row.id,
        name: row.name,
        actions: __jsx(_Space, {
          size: "small"
        }, __jsx(ExploreSelect, {
          experiment: row
        }), __jsx(DownloadButton, {
          experiment: row
        }), row.pipelineSummaryReportUrl && __jsx(_Tooltip, {
          title: "Pipeline Summary Report"
        }, __jsx(_Button, {
          "aria-label": "Pipeline Summary Report",
          icon: __jsx(FileTextOutlined, null),
          onClick: function onClick() {
            return window.open(row.pipelineSummaryReportUrl, '_blank', 'noreferrer');
          }
        }))),
        publication: __jsx("a", {
          href: row.publicationUrl
        }, row.publicationTitle),
        dataSource: __jsx("a", {
          href: row.dataSourceUrl
        }, row.dataSourceTitle),
        species: row.species,
        sampleCount: row.sampleCount,
        cellCount: row.cellCount,
        sampleTechnologies: "".concat(row.sampleTechnologies.map(function (tech) {
          return getTechNameToDisplay(tech);
        }).join(', ')),
        description: row.description,
        license: LICENSE_URLS[row.license] ? __jsx("a", {
          href: LICENSE_URLS[row.license],
          target: "_blank",
          rel: "noreferrer"
        }, row.license) : row.license,
        pipelineSummaryReportUrl: row.pipelineSummaryReportUrl
      };
    });
  };
  var data = props.data;
  var filteredData = data.filter(function (row) {
    return matchesSearch(row, searchQuery);
  });
  var formattedData = formatData(filteredData);
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var onCloseTable = function onCloseTable() {
    navigateTo(modules.DATA_MANAGEMENT);
  };
  var emptyDescription = searchQuery ? 'No experiments match your search.' : 'There are no experiments in the repository yet.';
  var locale = {
    emptyText: __jsx(_Empty, {
      imageStyle: {
        height: 60
      },
      description: __jsx(_Space, {
        size: "middle",
        direction: "vertical"
      }, __jsx(Paragraph, null, emptyDescription))
    })
  };
  return __jsx(_Card, {
    title: "Public Datasets Repository",
    extra: __jsx(_Button, {
      onClick: onCloseTable
    }, __jsx(CloseOutlined, null))
  }, __jsx(_Input, {
    placeholder: "Search datasets\u2026",
    prefix: __jsx(SearchOutlined, null),
    allowClear: true,
    value: searchQuery,
    onChange: function onChange(e) {
      setSearchQuery(e.target.value);
      router.replace({
        query: {
          search: e.target.value
        }
      }, undefined, {
        shallow: true
      });
    },
    style: {
      marginBottom: 16
    }
  }), __jsx(_Table, {
    dataSource: formattedData,
    columns: TABLE_COLUMNS,
    locale: locale,
    showHeader: formattedData.length > 0,
    pagination: false
  }));
};
RepositoryTable.defaultProps = {
  data: []
};
var TABLE_COLUMNS = [{
  title: 'Actions',
  dataIndex: 'actions',
  key: 'actions'
}, {
  title: 'Dataset name',
  dataIndex: 'name',
  key: 'name'
}, {
  title: 'Publication',
  dataIndex: 'publication',
  key: 'publication'
}, {
  title: 'Data Source',
  dataIndex: 'dataSource',
  key: 'dataSource'
}, {
  title: 'Species',
  dataIndex: 'species',
  key: 'species'
}, {
  title: 'Sample Count',
  dataIndex: 'sampleCount',
  key: 'sampleCount'
}, {
  title: 'Cell Count Estimate',
  dataIndex: 'cellCount',
  key: 'cellCount'
}, {
  title: 'Technologies',
  dataIndex: 'sampleTechnologies',
  key: 'sampleTechnologies'
}, {
  title: 'Short description',
  dataIndex: 'description',
  key: 'description'
}, {
  title: 'License',
  dataIndex: 'license',
  key: 'license'
}];
export default RepositoryTable;